import { ref } from 'vue';

const tooltipData = ref({});
const x = ref(null);
const y = ref(null);
const tooltipId = 'thn--chart-tooltip';
const tooltipRef = ref(null);

const setPos = (newX, newY) => {
  x.value = newX;
  y.value = newY;
};

const setTooltipData = (data) => {
  tooltipData.value = data;
};

export default function useTooltipState() {
  return {
    x,
    y,
    tooltipData,
    tooltipId,
    tooltipRef,

    setTooltipData,
    setPos,
  };
}
